var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 22.6914C5.85 22.6914 1.25 18.0914 1.25 12.4414C1.25 6.79141 5.85 2.19141 11.5 2.19141C17.15 2.19141 21.75 6.79141 21.75 12.4414C21.75 18.0914 17.15 22.6914 11.5 22.6914ZM11.5 3.69141C6.67 3.69141 2.75 7.62141 2.75 12.4414C2.75 17.2614 6.67 21.1914 11.5 21.1914C16.33 21.1914 20.25 17.2614 20.25 12.4414C20.25 7.62141 16.33 3.69141 11.5 3.69141Z",
    fill: "#B49345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0014 23.6918C21.8114 23.6918 21.6214 23.6218 21.4714 23.4718L19.4714 21.4718C19.1814 21.1818 19.1814 20.7018 19.4714 20.4118C19.7614 20.1218 20.2414 20.1218 20.5314 20.4118L22.5314 22.4118C22.8214 22.7018 22.8214 23.1818 22.5314 23.4718C22.3814 23.6218 22.1914 23.6918 22.0014 23.6918Z",
    fill: "#B49345"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.24c398afc294383622cd8755d5ed6d2a.svg";
export { ForwardRef as ReactComponent };